/**
 * Fact
 * This is a data visualization element to highlight a specific data point
 */
import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { Typography } from '../..';
const Fact = ({ header, subheader }) => {
    const useStyles = makeStyles((theme) => createStyles({
        fact: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: theme.spacing(0, 1),
            margin: theme.spacing(0, 2),
        },
    }));
    const classes = useStyles();
    return (React.createElement("div", { className: classes.fact },
        React.createElement(Typography, { color: "textPrimary", variant: "h6", fontWeight: "medium", align: "center" }, header),
        React.createElement(Typography, { color: "textSecondary", variant: "caption", align: "center" }, subheader)));
};
export { Fact };
//# sourceMappingURL=Fact.js.map